import Component from './unlock-interview-popup';

export default Component;
